import React from 'react';
import NodeWrapper, {Title} from './NodeWrapper';

const LabelNode = (props) => {
  return (
    <NodeWrapper type="label_node">
      <div className='labe-node'>
      <Title style={{fontSize:80}} title={`${props.data.label}`} />
      </div>
    </NodeWrapper>
  );
};

export default LabelNode;